import React, { useEffect, useRef, useState } from 'react';
import Chart from 'chart.js/auto';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import TrendOverlay from '../../card/TrendOverlay/TrendOverlay';
import './TrendChart.scss';
// import { useDispatch } from 'react-redux';

const TrendChart = ({ data, paymentData, debtAmountData }) => {

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const chartRef = useRef(null);
  let chartInstance = useRef(null);

  useEffect(() => {
    if (data && data.labels && data.datasets && chartRef.current) {
      const ctx = chartRef.current.getContext('2d');

      // const currentMonthIndex = new Date().getMonth();
      // Destroy the exiting chart instance if it exists
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
      // Create a new chart instance
      chartInstance.current = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: data.labels,
          datasets: data.datasets.map(dataset => ({
            label: dataset.label,
            data: dataset.data,
            backgroundColor: dataset.backgroundColor,
            borderColor: dataset.borderColor,
            borderWidth: 1
          }))
        },
        options: {
          scales: {
            x: {
              stacked: true
            },
            y: {
              stacked: true,
              ticks: {
                stepSize: 10,
                beginAtZero: true
              }
            }
          }
        }
      });
    }

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data]);

  const openModal = () => {
    setModalIsOpen(true);
  }

  const closeModal = () => {
    setModalIsOpen(false)
  }

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Agents Table Modal"
        className="modal"
        style={{
          overlay: {
            backgroundColor: 'rgba(45, 45, 45, 0.8)',
          },
        }}
      >
        <TrendOverlay paymentData = {paymentData} debtAmountData = {debtAmountData} data = {data}/>
      </Modal>
      {/* <div>
        <h3>Yearly Collection Trend</h3>
      </div> */}
      <div className='header'>
        <p>Yearly Collection Trends</p>
      </div>
      <canvas ref={chartRef} width="1700" height="500"></canvas>
      <div className='footer'>
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="27" onClick={openModal} viewBox="0 0 26 27" fill="none">
          <path d="M21.7092 12.5384L15.8723 5.78401C15.4704 5.31889 14.8198 5.31889 14.437 5.78401C14.0351 6.24914 14.0351 7.00207 14.437 7.44487L18.5516 12.2062L4.84925 12.2062C4.29431 12.2062 3.83492 12.7378 3.83492 13.3799C3.83492 14.0221 4.29431 14.5537 4.84925 14.5537L18.5324 14.5537L14.437 19.3149C14.0351 19.7801 14.0351 20.533 14.437 20.9759C14.6285 21.1974 14.8964 21.3302 15.1643 21.3302C15.4322 21.3302 15.681 21.2195 15.8915 20.9759L21.7476 14.1993C21.939 13.9778 22.0538 13.6678 22.0538 13.3578C22.0155 13.07 21.9007 12.76 21.7092 12.5384Z" fill="#D9D9D9" />
        </svg>
      </div>
    </>
  );
};

TrendChart.propTypes = {
  debtAmountData: PropTypes.array,
  paymentData: PropTypes.array,
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    datasets: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        data: PropTypes.arrayOf(PropTypes.number).isRequired,
        backgroundColor: PropTypes.string.isRequired,
        borderColor: PropTypes.string.isRequired
      })
    ).isRequired
  }).isRequired
};

export default TrendChart;
